"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CALL_API = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = _interopRequireDefault(require("lodash"));

/* eslint-disable @typescript-eslint/no-explicit-any */
// property assigned to API calls so that the middleware can identify them
var CALL_API = 'Call API';
/**
 * A function that accepts an auth manager instance, and returns a redux API Middleware that will
 * pass API calls through the authGuard, allowing for re-authentication and retry of request when 401
 * requests are received
 */

exports.CALL_API = CALL_API;
var _default = function _default(authManager) {
  return (
    // return redux middleware
    function () {
      return function (next) {
        return function (action) {
          // get the `CALL_API` property on the action
          var apiCall = _lodash.default.get(action, CALL_API); // if undefined, it's not an api call, so pass it to the next() middleware

          if (_lodash.default.isUndefined(apiCall)) {
            return next(action);
          } // else, it is an API call, so we destructure the properties we need

          var _apiCall$types = (0, _slicedToArray2.default)(apiCall.types, 3),
            requestType = _apiCall$types[0],
            successType = _apiCall$types[1],
            failureType = _apiCall$types[2],
            request = apiCall.request,
            misc = apiCall.misc,
            callback = apiCall.callback,
            errorCallback = apiCall.errorCallback; // dispatch the "_REQUEST" action

          next({
            type: requestType,
            misc: misc
          }); // handler for when the API call succeeds

          var handleSuccess = function handleSuccess(response) {
            // we dispatch the _SUCCESS type, with the response and misc data
            next({
              type: successType,
              response: response || {},
              misc: misc
            }); // if a callback was provided, we pass it the data

            if (callback) callback(response);
          }; // handler for when the api API call fails

          var handleError = function handleError(error) {
            // we dispatch the _FAILURE type, with the response and misc data
            next({
              type: failureType,
              response: _lodash.default.get(error, ['response', 'data'], {}),
              misc: misc
            });
            if (errorCallback) errorCallback(error);
          }; // use authGuard to execute the request

          authManager.authGuard(request, handleSuccess, handleError);
        };
      };
    }
  );
};
exports.default = _default;